export default __webpack_public_path__ + "static/media/downloadIconHC.63751b02.svg";